import script from "./ViewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewComponent.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./ViewComponent.vue?vue&type=style&index=1&id=0efc72c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efc72c9"]])

export default __exports__